"use client";

import Link from "next/link";
import { trackEvent, trackMetaEvent } from "@/lib/analytics";

export function ContactCta({ children, className, location }: { children: React.ReactNode; className: string; location: string }) {
  return (
    <Link
      href="/contact"
      className={className}
      onClick={() => {
        trackEvent("cta_click", { cta_type: "b2b_contact", location, label: "Solicită o prezentare" });
        trackMetaEvent("InitiateContact", { location });
      }}
    >
      {children}
    </Link>
  );
}

export function CalculatorCta({ children, className }: { children: React.ReactNode; className: string }) {
  return (
    <a
      href="#calculator"
      className={className}
      onClick={() => trackEvent("cta_click", { cta_type: "b2b_calculator", location: "organizatii", label: "Calculator costuri" })}
    >
      {children}
    </a>
  );
}
